// historico-facturas.service.js
"use strict";

class historicoFacturasService {
  constructor($http) {
    this.$http = $http;
    this.url = {
      invoice_file: '/api/customer/invoices/',
      pay_invoice: '/api/billing/payBillLink'
    };
  }

  download(id, serviceId, year) {
    return this.$http
    .get(this.getInvoiceFileUrl(id, serviceId, year), {responseType: 'blob'})
    .catch((error) => {
      throw error;
    });
  }

  getInvoiceFileUrl(id, serviceId, year) {
    return this.url.invoice_file + id + "/file" +
    "?serviceId=" + serviceId + "&year=" + year;
  }

  payBilling(orderID, orderAmount, orderData, serviceId, year) {
    return this.$http
      .post(this.url.pay_invoice,
        {"orderID": orderID,
        "orderAmount": orderAmount,
        "orderData": orderData,
        "serviceId": serviceId,
        "year": year
        })
      .then(data => data.data)
      .catch((error) => {
        throw error;
      });
  }

}

historicoFacturasService.$inject = ["$http"];

export { historicoFacturasService as HISTORICO_FACTURAS_SERVICE };
